import { gql } from '@apollo/client';

const getEnvironmentSalmGroups = (environmentUri: string) => {
    return {
        variables: {
            environmentUri,
        },
        query: gql`
            query GetEnvironment($environmentUri: String) {
                getEnvironment(environmentUri: $environmentUri) {
                    originSamlGroupName
                    originSamlFullDevGroupName
                    originSamlBasicDevGroupName
                    originSamlReaderGroupName
                    SamlReaderGroupName
                    SamlBasicDevGroupName
                    SamlFullDevGroupName
                    SamlGroupName
                }
            }
        `,
    };
};

export default getEnvironmentSalmGroups;
